export default __webpack_public_path__ + "static/media/maintenance_mode.b87ecc62.svg";